import { GENDER_CODES } from "$routes/_lib/constants";
import { Box } from "@material-ui/core";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";

const PatientDetails = ({ patientDetails }) => {
  const { firstname, lastname } = patientDetails?.person?.name;
  const cardId = patientDetails.cardId || patientDetails?.passport?.uid;

  return (
    <Box display="flex" flexDirection="column" mb={2}>
      <span>
        <FormattedMessage
          id="invoice.laserReceipt.patient.name"
          defaultMessage="Patient name: {first} {last}"
          values={{
            first: firstname ?? "",
            last: lastname ?? "",
          }}
        />
      </span>
      {cardId && (
        <span>
          <FormattedMessage
            id="invoice.laserReceipt.patient.id"
            defaultMessage="Patient ID: {cardId}"
            values={{
              cardId,
            }}
          />
        </span>
      )}
    </Box>
  );
};

/** @deprecated Needs to be converted into TS types */
const GenderCodeType = PropTypes.oneOf(Object.values(GENDER_CODES));

/** @deprecated Needs to be converted into TS types */
const BasicInformationType = PropTypes.shape({
  firstname: PropTypes.string,
  lastname: PropTypes.string,
  middlename: PropTypes.string,
  dob: PropTypes.string,
  gender: GenderCodeType,
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      locale: PropTypes.string,
    }),
  ),
  maritalstatus: PropTypes.string,
});

/** @deprecated Needs to be converted into TS types */
const PatientDetailsType = PropTypes.shape({
  uuid: PropTypes.string,
  basicInformation: BasicInformationType,
});

/** @deprecated Needs to be converted into TS types */
PatientDetails.propTypes = {
  patientDetails: PatientDetailsType,
  cardId: PropTypes.string.isRequired,
};

/** @deprecated Needs to be converted into TS types */
PatientDetails.defaultProps = {
  patientDetails: undefined,
};

export default PatientDetails;
